<form [formGroup]="form" class="d-grid gap-2">
  <!-- Name Input -->
  <div>
    <label for="name" class="form-label">Name</label>
    <input type="text" id="name" formControlName="name" class="form-control"
      [class.is-invalid]="name.invalid && name.touched">
      @if (name.invalid) {
        <div class="invalid-feedback">Name is required.</div>
      }
    </div>

    <!-- Image Input -->
    <div>
      <label for="image" class="form-label">Image</label>
      <input type="file" accept="image/*" id="image" class="form-control" (change)="setImage($event.target.files[0])"
        [class.is-invalid]="image.invalid && image.touched">
        @if (image.errors?.required) {
          <div class="invalid-feedback">Image is required.</div>
        }
      </div>
    </form>